import { render } from "./PlanBathAdd.vue?vue&type=template&id=487ce596"
import script from "./PlanBathAdd.vue?vue&type=script&lang=js"
export * from "./PlanBathAdd.vue?vue&type=script&lang=js"

import "./PlanBathAdd.vue?vue&type=style&index=0&id=487ce596&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__